import { Globe } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import { Card, CardContent } from "@/components/ui/card";
import type { SiteWanUplink } from "@/api/schemas/sites";

function DnsRow({ label, value }: { label: string; value: string | null }) {
  return (
    <>
      <div className="text-fg-mute">{label}</div>
      <div className="text-right font-mono text-fg">{value ?? "-"}</div>
    </>
  );
}

export function ApplianceStatusRail({
  uplinks,
  siteCode,
  friendlyName,
}: {
  uplinks: SiteWanUplink[];
  siteCode: string;
  friendlyName: string;
}) {
  return (
    <Card>
      <CardContent className="flex flex-col gap-3">
        <div>
          <div className="font-mono text-[10.5px] uppercase tracking-[0.12em] text-fg-mute">
            Appliance Status
          </div>
          <div className="mt-0.5 text-base font-bold text-fg">{siteCode}</div>
          <div className="font-mono text-[10.5px] text-fg-mute">
            {friendlyName}
          </div>
        </div>
        {uplinks.map((u) => (
          <div
            key={u.label}
            className="rounded-xl border border-line bg-surface-tint/40 p-3"
          >
            <div className="flex items-center justify-between">
              <div className="flex items-center gap-2 text-sm font-semibold text-fg">
                <Globe size={14} className="text-violet" />
                {u.label}
                <span className="font-mono text-[10.5px] text-fg-mute">
                  · {u.model}
                </span>
              </div>
              <Badge
                variant={
                  u.state === "active"
                    ? "ok"
                    : u.state === "ready"
                      ? "info"
                      : "err"
                }
                size="sm"
              >
                {u.state === "active"
                  ? "Active"
                  : u.state === "ready"
                    ? "Ready"
                    : "Down"}
              </Badge>
            </div>
            <div className="mt-2 grid grid-cols-2 gap-y-1 text-[11px]">
              <DnsRow label="Public IP" value={u.publicIp} />
              <DnsRow label="LAN IP" value={u.lanIp} />
              <DnsRow label="Gateway" value={u.gateway} />
              <DnsRow label="Primary DNS" value={u.primaryDns} />
              <DnsRow label="Secondary DNS" value={u.secondaryDns} />
            </div>
          </div>
        ))}
      </CardContent>
    </Card>
  );
}
